import {
  HStack,
  Heading,
  IconButton,
  Stack,
  StackProps,
  Text,
  VStack
} from "@chakra-ui/react"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import useCopyToClipboard from "@pathwright/utils/src/clipboard/useCopyToClipboard"
import UserAvatar from "@pathwright/ux/src/components/avatar/UserAvatar"
import { ContextFragment } from "../api/generated"
import MaxLastSeen from "../user/MaxLastSeen"
import SchoolMembershipRoleBadge from "./SchoolMembershipRoleBadge"

const Email = ({ email }: { email: string }) => {
  const copyToClipboard = useCopyToClipboard()

  return (
    <HStack spacing={1} color="TERTIARY_GRAY">
      <Pathicon icon="envelope" />
      <Text as="span" color="inherit">
        {email}
      </Text>
      <IconButton
        aria-label="Copy email"
        icon={<Pathicon icon="copy" />}
        onClick={() => copyToClipboard(email)}
        variant="ghost"
        cursor="pointer"
        isRound
        h="6"
        minW="6"
        color="TERTIARY_GRAY"
      />
    </HStack>
  )
}

type ProfileUserCardProps = {
  user: NonNullable<ContextFragment["me"]>
} & StackProps

function ProfileUserCard({ user, ...stackProps }: ProfileUserCardProps) {
  return (
    <Stack
      as="header"
      className="ProfileUserCard"
      direction={["column", "row"]}
      align={["center", "flex-start"]}
      p={4}
      bg="white"
      borderRadius="20px"
      w="100%"
      pos="relative"
      {...stackProps}
    >
      <UserAvatar user={user} size="lg" />
      <VStack align={["center", "flex-start"]} spacing={[4, 2]} w="100%">
        <Heading
          as="h1"
          className="theme-heading theme-heading-bold"
          fontSize="lg"
          m={0}
        >
          {user.full_name}
        </Heading>

        <Stack
          direction={["column", "row"]}
          spacing={[1, 2]}
          align={["flex-start", "center"]}
          wrap="wrap"
          w="100%"
        >
          {!!user.profile?.bio && (
            <Text m={0} flexBasis="100%" color="TERTIARY_GRAY">
              {user.profile.bio}
            </Text>
          )}
          {(user.membership?.role || 0) > 5 && (
            <SchoolMembershipRoleBadge role={user.membership?.role!} />
          )}
          {/* MaxLastSeen is currentlly written in JS (not TSX) and props
            are inferred as required. */}
          {/* @ts-expect-error: */}
          <MaxLastSeen user={user} />
          <Email email={user.email!} />
        </Stack>
      </VStack>
    </Stack>
  )
}

export default ProfileUserCard
